import React from 'react';
import { X } from 'lucide-react';
import { sizeGuide } from '../mockData';

const SizeGuidePopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: 'var(--bg-primary)',
          maxWidth: '700px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '40px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
            <h2 className="heading-1">Size Guide</h2>
            <button 
              onClick={onClose}
              className="btn-icon"
              aria-label="Close"
            >
              <X size={24} />
            </button>
          </div>

          <p className="body-regular" style={{ marginBottom: '32px', color: 'var(--text-secondary)' }}>
            All SOLENNE shoes are crafted on traditional Italian lasts. We recommend selecting your usual size for the perfect fit. For half sizes, we suggest sizing up.
          </p>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border-light)' }}>
                  <th className="body-small" style={{ padding: '16px', textAlign: 'left', fontWeight: 700 }}>US</th>
                  <th className="body-small" style={{ padding: '16px', textAlign: 'left', fontWeight: 700 }}>EU</th>
                  <th className="body-small" style={{ padding: '16px', textAlign: 'left', fontWeight: 700 }}>UK</th>
                  <th className="body-small" style={{ padding: '16px', textAlign: 'left', fontWeight: 700 }}>CM</th>
                </tr>
              </thead>
              <tbody>
                {sizeGuide.map((size, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid var(--border-subtle)' }}>
                    <td className="body-regular" style={{ padding: '16px' }}>{size.us}</td>
                    <td className="body-regular" style={{ padding: '16px' }}>{size.eu}</td>
                    <td className="body-regular" style={{ padding: '16px' }}>{size.uk}</td>
                    <td className="body-regular" style={{ padding: '16px' }}>{size.cm}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ marginTop: '32px', padding: '24px', background: 'var(--bg-secondary)' }}>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              <strong>Fitting Advice:</strong> If you're between sizes or have wider feet, we recommend sizing up. Our customer service team is available to provide personalized fitting advice.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeGuidePopup;
